import React, { useState, useCallback, useMemo } from 'react';
import { Input } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SearchOutlined } from '@ant-design/icons';

import styles from './HelpBanner.module.css';

const HelpBanner = React.memo(() => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const handleSearch = useCallback((value) => {
    if (value.trim()) {
      navigate(`/search?query=${encodeURIComponent(value.trim())}`);
    }
  }, [navigate]);

  const handleSearchClick = useCallback(() => {
    handleSearch(searchTerm);
  }, [handleSearch, searchTerm]);

  const handleSearchChange = useCallback((e) => {
    setSearchTerm(e.target.value);
  }, []);

  const handleSearchEnter = useCallback(() => {
    handleSearch(searchTerm);
  }, [handleSearch, searchTerm]);

  const handleTopicClick = useCallback((e, topicKey) => {
    e.preventDefault();
    navigate(`/search?query=${encodeURIComponent(topicKey)}`);
  }, [navigate]);

  const popularTopics = useMemo(() => [
    { key: 'account management', label: 'Account Management' },
    { key: 'product', label: 'Product' },
    { key: 'booking support', label: 'Booking Support' },
    { key: 'payment', label: 'Payment' },
    { key: 'sales', label: 'Sales' },
    { key: 'reports', label: 'Reports' }
  ], []);

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <h1>
          {t('banner.title.line1')}<br />
          {t('banner.title.line2')}<br />
          {t('banner.title.line3')}
        </h1>
        <p>{t('banner.subtitle')}</p>

        <div className={styles.searchBar}>
          <Input
            placeholder={t('banner.searchPlaceholder')}
            allowClear
            size="large"
            className={styles.searchInput}
            value={searchTerm}
            onChange={handleSearchChange}
            onPressEnter={handleSearchEnter}
            prefix={<SearchOutlined style={{ color: '#666' }} />}
          />
          <button 
            className={styles.searchButton}
            onClick={handleSearchClick}
          >
            {t('banner.searchButton')}
          </button>
        </div>

        <div className={styles.popularTopics}>
          <span>{t('banner.popularTopics')}</span>
          {popularTopics.map((topic, index) => (
            <a 
              key={index} 
              href={`/search?query=${encodeURIComponent(topic.key)}`}
              onClick={(e) => handleTopicClick(e, topic.key)}
            >
              {topic.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
});

HelpBanner.displayName = 'HelpBanner';

export default HelpBanner;
